import React, { Fragment, useEffect, useState } from "react";
import {
  adminplayerstatistics,
  dashboardcount,
  webpagetrackinglist,
} from "../../../services/superadmin";
import { Col, Modal, Row } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import moment from "moment";
import { calendarlistcommon } from "../../../services/common";
import { sportslist } from "../../../services/master";
import Select from "react-select";
import dotracking from "../../trackinglogs";
import trackobj from "../../trackingpages.json";
import { useNavigate } from "react-router-dom";

export const Dashboard = () => {
  const navigate = useNavigate();
  const [pcount, setPCount] = useState(0);
  const [ccount, setCCount] = useState(0);
  const [shcount, setSHCount] = useState(0);
  const [rcount, setRCount] = useState(0);

  const [mlist, setMList] = useState([]);
  const [slist, setSportList] = useState([]);
  const [tsport, setTSport] = useState("");
  const [tvalue, setTValue] = useState("");
  const [tyear, setTYear] = useState(0);
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;

  const [stype, setSType] = useState("");

  const [wcount, setWCount] = useState(0);
  const [ucount, setUCount] = useState(0);
  const [clist, setCList] = useState([]);

  const [fwcount, setFWCount] = useState(0);
  const [fucount, setFUCount] = useState(0);
  const [fclist, setFCList] = useState([]);


    const [gwcount, setGWCount] = useState(0);
  const [gucount, setGUCount] = useState(0);
  const [gclist, setGCList] = useState([]);

  const [sdate, setSDate] = useState("");
  const [edate, setEDate] = useState("");

  useEffect(() => {
    dashboardcount().then((response) => {
      if (response.status === true) {
        setPCount(response.data.all_players_count);
        setCCount(response.data.all_cityadmin_count);
        setSHCount(response.data.all_schoolheads_count);
        setRCount(response.data.all_referees_count);
      }
    });

    sportslist().then((response) => {
      if (response.status === true) {
        if (response.data.length > 0) {
          let arr = [];
          for (let i = 0; i < response.data.length; i++) {
            arr.push({
              value: response.data[i].sports_cat_uid,
              label: response.data[i].sports_category,
            });
          }
          setSportList(arr);
        }
      }
    });

    calendarlistcommon().then((response) => {
      if (response.status === true) {
        let schedule = [];
        if (response.data.tournament_and_events.length !== 0) {
          for (let i = 0; i < response.data.tournament_and_events.length; i++) {
            var clr = "";
            var clink = "";
            const url = window.location.href;
            const head = url.split("/#/");
            if (response.data.tournament_and_events[i].type === "Tournament") {
              clr = "#005baa";
              clink =
                `${head[0]}/#/superadmin/tournamentdetail/` +
                response.data.tournament_and_events[i].id;
            } else if (
              response.data.tournament_and_events[i].type === "External" ||
              response.data.tournament_and_events[i].type === "External_1"
            ) {
              clr = "#c21a1a";
              clink =
                `${head[0]}/#/superadmin/externaltournamentdetail/` +
                response.data.tournament_and_events[i].id;
            } else {
              clr = "#e59216";
              clink =
                `${head[0]}/#/superadmin/othereventdetails/` +
                response.data.tournament_and_events[i].id;
            }
            schedule.push({
              title: response.data.tournament_and_events[i].meet_name,
              start: response.data.tournament_and_events[i].startdate,
              end: response.data.tournament_and_events[i].enddate,
              description: response.data.tournament_and_events[i].type,
              url: clink,
              color: clr,
            });
          }
          setEvents(schedule);
        }
      }
    });

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    let startYear = currentYear;
    if (currentMonth < 3) {
        startYear = currentYear - 1;
    }
    var d = new Date(startYear, 3, 1);
    const tdate = moment(d).format("YYYY-MM-DD");

    setSDate(tdate);
    setEDate(moment(new Date()).format("YYYY-MM-DD"));


    // const currentYear = new Date().getFullYear();
    // var d = new Date(currentYear, 3, 1);
    // const tdate = moment(d).format("YYYY-MM-DD");
    // setSDate(tdate);
    // setEDate(moment(new Date()).format("YYYY-MM-DD"));
    liststats(tdate, moment(new Date()).format("YYYY-MM-DD"));
    listall("", "",0);
  }, []);

  function liststats(sdte, tdte) {
    setFWCount(0);
    setGWCount(0);
    setUCount(0);
    setCList([]);
    setSDate(sdte);
    setEDate(tdte);
    const temp1 = new FormData();
    temp1.append("start_date", sdte);
    temp1.append("end_date", tdte);
    temp1.append("school_funder_group_id", 0);
    temp1.append("school_funder_group_type", 1);

    webpagetrackinglist(temp1).then((response) => {
      if (response.status === true) {
        setWCount(response.data.webpages_count);
        setUCount(response.data.users_count);
        setCList(response.data.tour_pages);
      }
    });

    const temp2 = new FormData();
    temp2.append("start_date", sdte);
    temp2.append("end_date", tdte);
    temp2.append("school_funder_group_id", 0);
    temp2.append("school_funder_group_type", 2);

    webpagetrackinglist(temp2).then((response) => {
      if (response.status === true) {
        setFWCount(response.data.webpages_count);
        setFUCount(response.data.users_count);
        setFCList(response.data.tour_pages);
      }
    });


    const temp3 = new FormData();
    temp3.append("start_date", sdte);
    temp3.append("end_date", tdte);
    temp3.append("school_funder_group_id", 0);
    temp3.append("school_funder_group_type", 3);

    webpagetrackinglist(temp3).then((response) => {
      if (response.status === true) {
        setGWCount(response.data.webpages_count);
        setGUCount(response.data.users_count);
        setGCList(response.data.tour_pages);
      }
      });
  }
  function handleSport(e) {
    if (e !== null) {
      setTSport(e);
      setTValue(e.value);
      listall(e.value, stype,tyear);
    } else {
      setTSport("");
      setTValue("");
      listall("", stype,tyear);
    }
  }

  function handleType(e) {
    if (e !== null) {
      setSType(e);
      listall(tvalue, e,tyear);
    } else {
      setSType("");
      listall(tvalue, "",tyear);
    }
  }

  function listall(spid, tyid,fyear) {
    setMList([]);
    setTYear(fyear)
    const temp = new FormData();
    temp.append("sports", spid);
    temp.append("school_id", tyid);
    temp.append("year", fyear);
    adminplayerstatistics(temp).then((res) => {
      if (res.status === true) {
        setMList(res.data);
      }
    });
  }

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [events, setEvents] = useState([]);

  const openModal = (event) => {
    setSelectedEvent(event);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedEvent("");
    setModalIsOpen(false);
  };

  const handleEventClick = (info) => {
    const clickedEvent = {
      title: info.event.title,
      start: info.event.startStr,
      end: info.event.endStr,
      description: info.event.description,
      sports: info.event.sports,
      event: info.event.event,
    };
    openModal(clickedEvent);
  };

  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">Dashboard</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Dashboard
            </li>
          </ol>
        </div>

        <div className="row row-cards">
          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-info">
                  <i className="icon-people text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total Players</p>
                <p className="h3 text-center text-info">{pcount}</p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-primary">
                  <i className="mdi mdi-account-network text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total Manager</p>
                <p className="h3 text-center text-primary-1">{ccount}</p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg fa-1x icons shadow-default bg-teal">
                  <i className="fa fa-bank text-white-1 text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total School Head</p>
                <p className="h3 text-center text-teal">{shcount}</p>
              </div>
            </div>
          </div>

          <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
            <div className="card bg-custom">
              <div className="card-body text-center feature">
                <div className="fa-stack fa-lg icons shadow-default bg-purple">
                  <i className="mdi mdi-account-convert text-white"></i>
                </div>
                <p className="card-text mt-3 mb-3">Total Referee</p>
                <p className="h3 text-center text-purple">{rcount}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="ag_courses_head">
          <h4>Players Statistics</h4>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">Sports</label>
            <Select
              className="dropdown"
              placeholder="Select Sports"
              value={tsport}
              options={slist}
              onChange={handleSport}
              isSearchable={true}
              isClearable
              hidden
            />
          </div>
          <div className="col-md-4">
            <label className="mb-2">School Type</label>
            <select
              className="form-control custom-select"
              value={stype}
              onChange={(e) => handleType(e.target.value)}
            >
              <option value="" defaultValue disabled>
                --- Select School Type ---
              </option>
              <option value="Private">Private</option>
              <option value="CSR">CSR</option>
              <option value="Government">Government</option>
            </select>
          </div>

          <div className="col-md-4">
            <label className="form-label">Financial Year</label>

            <select className="form-control" value={tyear} onChange={(e) => listall(tsport, stype,e.target.value)}>
              <option value={0}>All</option>
              <option value={currentYear}>Current Year</option>
              <option value={lastYear}>Last Year</option>
            </select>
          </div>
        </div>

        <div className="row">
          <div className="col-md-5">
            <div className="table-responsive">
              <table className="sp-league-table sp-data-table">
                <thead className="sp-table-header">
                  <tr role="row">
                    <th className="text-center">Players</th>
                    <th className="text-center">Male</th>
                    <th className="text-center">Female</th>
                    <th className="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {mlist.map((item, j) => {
                    const getRowColor = () => {
                      return j % 2 === 0 ? "even" : "odd";
                    };
                    return (
                      <>
                        <tr
                          className={`sp-row-no-0 ${getRowColor()}`}
                          role="row"
                          key={j}
                          onClick={() => {
                            localStorage.getItem("Page", 1);
                            dotracking(
                              "view individual list of tournament type in dashboard for " +
                                item.meet_type +
                                " $$ " +
                                trackobj.achievelistheading
                            );
                            navigate(
                              "/superadmin/individualachievementlist/" +
                                item.meet_type
                            );
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <td className="data-pct">{item.meet_type}</td>
                          <td className="data-pct">{item.male_count}</td>
                          <td className="data-pct">{item.female_count}</td>
                          <td className="data-pct">
                            {item.male_count + item.female_count}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-7">
            <div className="table-responsive">
              <table className="sp-league-table sp-data-table">
                <thead className="sp-table-header">
                  <tr role="row">
                    <th className="text-center">Players</th>
                    <th className="text-center">&lt;8 Years</th>
                    <th className="text-center">8-14 Years</th>
                    <th className="text-center">15-18 Years</th>
                    <th className="text-center">&gt;18 Years</th>
                    <th className="text-center">Total</th>
                  </tr>
                </thead>
                <tbody>
                  {mlist.map((item, j) => {
                    const getRowColor = () => {
                      return j % 2 === 0 ? "even" : "odd";
                    };
                    return (
                      <>
                        <tr
                          className={`sp-row-no-0 ${getRowColor()}`}
                          role="row"
                          key={j}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            localStorage.getItem("Page", 1);
                            dotracking(
                              "view individual list of tournament type in dashboard for " +
                                item.meet_type +
                                " $$ " +
                                trackobj.achievelistheading
                            );
                            navigate(
                              "/superadmin/individualachievementlist/" +
                                item.meet_type
                            );
                          }}
                        >
                          <td className="data-pct">{item.meet_type}</td>
                          <td className="data-pct">
                            {item.female_age_8 + item.male_age_8}
                          </td>
                          <td className="data-pct">
                            {item.female_age_8_14 + item.male_age_8_14}
                          </td>
                          <td className="data-pct">
                            {item.female_age_15_18 + item.male_age_15_18}
                          </td>
                          <td className="data-pct">
                            {item.female_age_18_plus + item.male_age_18_plus}
                          </td>

                          <td className="data-pct">
                            {item.female_age_8 +
                              item.male_age_8 +
                              item.female_age_8_14 +
                              item.male_age_8_14 +
                              item.female_age_15_18 +
                              item.male_age_15_18 +
                              item.female_age_18_plus +
                              item.male_age_18_plus}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <hr />
        <div className="text-center">
          <h3>Webpage Statistics</h3>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={sdate}
                onChange={(e) => liststats(e.target.value, edate)}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">Ends Date</label>
              <input
                type="date"
                className="form-control"
                value={edate}
                onChange={(e) => liststats(sdate, e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="ag_courses_head">
            <h4>School Webpage Statistics</h4>
          </div>
          <div className="col-md-3">
            <div className="card bg-webpage">
              <div className="card-body text-center feature">
                <p
                  className="card-text mt-3 mb-3"
                  style={{ fontWeight: "700" }}
                >
                  {" "}
                  Webpage Count
                </p>
                <p className="h3 text-center text-primary-1">{wcount}</p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-webpage">
              <div className="card-body text-center feature">
                <p
                  className="card-text mt-3 mb-3"
                  style={{ fontWeight: "700" }}
                >
                  {" "}
                  Unique Users Count <br />
                  (Group by IP Address)
                </p>
                <p className="h3 text-center text-primary-1">{ucount}</p>
              </div>
            </div>
          </div>

          {clist.map((item, i) => {
            return (
              <>
                <div className="col-md-3" key={i}>
                  <div className="card bg-webpage">
                    <div className="card-body text-center feature">
                      <p
                        className="card-text mt-3 mb-3"
                        style={{ fontWeight: "700" }}
                      >
                        {" "}
                        {item.current_page === "Products" ? "View All Products" : item.current_page} Count
                      </p>
                      <p className="h3 text-center text-primary-1">
                        {item.users_count}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>

        <div className="row">
          <div className="ag_courses_head">
            <h4>Funder Webpage Statistics</h4>
          </div>
          <div className="col-md-3">
            <div className="card bg-webpage">
              <div className="card-body text-center feature">
                <p
                  className="card-text mt-3 mb-3"
                  style={{ fontWeight: "700" }}
                >
                  {" "}
                  Webpage Count
                </p>
                <p className="h3 text-center text-primary-1">{fwcount}</p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-webpage">
              <div className="card-body text-center feature">
                <p
                  className="card-text mt-3 mb-3"
                  style={{ fontWeight: "700" }}
                >
                  {" "}
                  Unique Users Count <br />
                  (Group by IP Address)
                </p>
                <p className="h3 text-center text-primary-1">{fucount}</p>
              </div>
            </div>
          </div>

          {fclist.map((item, i) => {
            return (
              <>
                <div className="col-md-3" key={i}>
                  <div className="card bg-webpage">
                    <div className="card-body text-center feature">
                      <p
                        className="card-text mt-3 mb-3"
                        style={{ fontWeight: "700" }}
                      >
                        {" "}
                        {item.current_page === "Products" ? "View All Products" : item.current_page} Count
                      </p>
                      <p className="h3 text-center text-primary-1">
                        {item.users_count}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>


        <div className="row">
          <div className="ag_courses_head">
            <h4>Group of School Webpage Statistics</h4>
          </div>
          <div className="col-md-3">
            <div className="card bg-webpage">
              <div className="card-body text-center feature">
                <p
                  className="card-text mt-3 mb-3"
                  style={{ fontWeight: "700" }}
                >
                  {" "}
                  Webpage Count
                </p>
                <p className="h3 text-center text-primary-1">{gwcount}</p>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card bg-webpage">
              <div className="card-body text-center feature">
                <p
                  className="card-text mt-3 mb-3"
                  style={{ fontWeight: "700" }}
                >
                  {" "}
                  Unique Users Count <br />
                  (Group by IP Address)
                </p>
                <p className="h3 text-center text-primary-1">{gucount}</p>
              </div>
            </div>
          </div>

          {gclist.map((item, i) => {
            return (
              <>
                <div className="col-md-3" key={i}>
                  <div className="card bg-webpage">
                    <div className="card-body text-center feature">
                      <p
                        className="card-text mt-3 mb-3"
                        style={{ fontWeight: "700" }}
                      >
                        {" "}
                        {item.current_page === "Products" ? "View All Products" : item.current_page} Count
                      </p>
                      <p className="h3 text-center text-primary-1">
                        {item.users_count}
                      </p>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
        </div>
        <hr />

        <div className="row">
          <div className="ag_courses_head">
            <h4>Tournament & Events Calender</h4>
          </div>
          <div className="col-12">
            <div className="card mt-0">
              <div className="card-body">
                <FullCalendar
                  plugins={[dayGridPlugin]}
                  initialView="dayGridMonth"
                  events={events}
                  eventClick={handleEventClick}
                />

                <Modal show={modalIsOpen} size="xl">
                  <Modal.Header>
                    <Modal.Title>Tournament & Events Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="table-responsive">
                      <table className="sp-league-table sp-data-table">
                        <thead className="sp-table-header">
                          <tr role="row">
                            <th className="text-center">Title</th>
                            <th className="text-center">Start Date</th>
                            <th className="text-center">End Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="sp-row-no-0 even" role="row">
                            <td class="data-pct">{selectedEvent.title}</td>
                            <td class="data-pct">
                              {moment(selectedEvent.start).format("DD-MM-YYYY")}
                            </td>
                            {selectedEvent.end !== "" && (
                              <td className="data-pct">
                                {moment(selectedEvent.end).format("DD-MM-YYYY")}
                              </td>
                            )}
                            {selectedEvent.end === "" && (
                              <td className="data-pct">
                                {moment(selectedEvent.start).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <a className="btn btn-gray" onClick={closeModal}>
                      Close
                    </a>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
